'use client';
import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const countries = [
  { id: 'country-all', label: 'All Africa', flag: '🌍', count: 47 },
  { id: 'country-ng', label: 'Nigeria', flag: '🇳🇬', count: 12 },
  { id: 'country-gh', label: 'Ghana', flag: '🇬🇭', count: 6 },
  { id: 'country-ke', label: 'Kenya', flag: '🇰🇪', count: 5 },
  { id: 'country-za', label: 'South Africa', flag: '🇿🇦', count: 7 },
  { id: 'country-eg', label: 'Egypt', flag: '🇪🇬', count: 4 },
  { id: 'country-et', label: 'Ethiopia', flag: '🇪🇹', count: 3 },
  { id: 'country-tz', label: 'Tanzania', flag: '🇹🇿', count: 3 },
  { id: 'country-ug', label: 'Uganda', flag: '🇺🇬', count: 2 },
  { id: 'country-sn', label: 'Senegal', flag: '🇸🇳', count: 2 },
  { id: 'country-ci', label: "Côte d\'Ivoire", flag: '🇨🇮', count: 2 },
  { id: 'country-cm', label: 'Cameroon', flag: '🇨🇲', count: 2 },
  { id: 'country-rw', label: 'Rwanda', flag: '🇷🇼', count: 2 },
  { id: 'country-zm', label: 'Zambia', flag: '🇿🇲', count: 1 },
  { id: 'country-zw', label: 'Zimbabwe', flag: '🇿🇼', count: 1 },
  { id: 'country-tz2', label: 'Tunisia', flag: '🇹🇳', count: 1 },
  { id: 'country-ma', label: 'Morocco', flag: '🇲🇦', count: 2 },
];

interface CountryFilterTabsProps {
  activeCountry?: string;
  onCountryChange?: (countryId: string) => void;
}

export default function CountryFilterTabs({ activeCountry = 'country-all', onCountryChange }: CountryFilterTabsProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir === 'left' ? -200 : 200, behavior: 'smooth' });
    }
  };

  return (
    <div className="relative flex items-center gap-1 sm:gap-2">
      <button
        onClick={() => scroll('left')}
        className="flex-shrink-0 p-1.5 text-[rgb(113,113,133)] hover:text-white hover:bg-[rgb(26,26,32)] rounded-lg transition-all"
        aria-label="Scroll left"
      >
        <ChevronLeft size={16} />
      </button>

      <div
        ref={scrollRef}
        className="flex items-center gap-1.5 sm:gap-2 overflow-x-auto scrollbar-hide flex-1"
      >
        {countries.map((c) => (
          <button
            key={c.id}
            onClick={() => onCountryChange?.(c.id)}
            className={`flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-full text-xs sm:text-sm font-500 whitespace-nowrap flex-shrink-0 transition-all duration-150 border ${
              activeCountry === c.id
                ? 'bg-[rgb(232,82,26)] border-[rgb(232,82,26)] text-white'
                : 'bg-[rgb(18,18,22)] border-[rgb(39,39,48)] text-[rgb(161,161,178)] hover:border-[rgb(232,82,26)] hover:text-white'
            }`}
          >
            <span>{c.flag}</span>
            <span>{c.label}</span>
            <span className={`text-[10px] tabular-nums ${activeCountry === c.id ? 'text-[rgba(255,255,255,0.7)]' : 'text-[rgb(113,113,133)]'}`}>
              {c.count}
            </span>
          </button>
        ))}
      </div>

      <button
        onClick={() => scroll('right')}
        className="flex-shrink-0 p-1.5 text-[rgb(113,113,133)] hover:text-white hover:bg-[rgb(26,26,32)] rounded-lg transition-all"
        aria-label="Scroll right"
      >
        <ChevronRight size={16} />
      </button>
    </div>
  );
}